import { render, staticRenderFns } from "./sanne.vue?vue&type=template&id=44b4d40c"
import script from "./sanne.vue?vue&type=script&lang=js"
export * from "./sanne.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports